var React = require('react');

function Compress (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M810.666667 384h-110.08l140.373333-140.373333a42.666667 42.666667 0 1 0-60.586667-60.586667L640 322.986667V213.333333a42.666667 42.666667 0 0 0-42.666667-42.666666 42.666667 42.666667 0 0 0-42.666666 42.666666v213.333334a42.666667 42.666667 0 0 0 42.666666 42.666666h213.333334a42.666667 42.666667 0 0 0 0-85.333333zM426.666667 554.666667H213.333333a42.666667 42.666667 0 0 0 0 85.333333h109.653334l-139.946667 140.373333a42.666667 42.666667 0 0 0 0 60.586667 42.666667 42.666667 0 0 0 60.586667 0L384 700.586667V810.666667a42.666667 42.666667 0 0 0 42.666667 42.666666 42.666667 42.666667 0 0 0 42.666666-42.666666v-213.333334a42.666667 42.666667 0 0 0-42.666666-42.666666z"}));
}

Compress.defaultProps = {"fill":"#ffffff","className":"svg-icon","viewBox":"0 0 1024 1024","version":"1.1"};

module.exports = Compress;

Compress.default = Compress;
